export default __webpack_public_path__ + "static/media/svg-3.59fe45d1.svg";